export { default as ArrowNarrowRightSolidIcon } from './ArrowNarrowRightSolidIcon';
